<template>
    <div class="modal modal-custom fade" data-backdrop="false" :id="id">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <p v-text="msg"></p>
                </div>
                <div class="modal-footer row">
                    <div class="col-xs-12">
                        <button type="button"
                            class="btn btn-success"
                            @click="submit"
                            v-text="submitBtnText"></button>
                        <button type="button"
                            class="btn
                            btn-default"
                            v-show="isShowCancelBtn"
                            @click="cancel">取消</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    props: {
        // modal ID
        id: {
            type: String,
            default: 'alertModal',
        },
        msg: {
            type: String,
            required: true,
        },
        // 開關控制 true: 開, false: 關
        triggerOpen: {
            type: Boolean,
            default: false,
        },
        // submit按鈕文字
        submitBtnText: {
            type: String,
            default: '確認',
        },
        callback: {
            default: null,
        },
        isShowCancelBtn: {
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        /**
         * toggle modal
         */
        toggleAlertModal() {
            const vm = this;
            $(`#${vm.id}`).modal('toggle');
        },
        /**
         * submit method
         */
        submit() {
            this.toggleAlertModal();
            if (this.callback) {
                this.callback();
            }
        },
        cancel() {
            this.toggleAlertModal();
        },
    },
    watch: {
        triggerOpen() {
            this.toggleAlertModal();
        },
    },
};
</script>

<style>
    .modal-custom .modal-dialog {
        margin-top: 25vh;
        margin-left: auto;
        margin-right: auto;
        max-width: 400px
    }

    .modal-custom .modal-content {
        border: none;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
        padding: 1em;
    }

    .modal-custom .modal-content p {
        color: #5e5e5e;
        line-height: 1.4;
    }

    .modal-custom .modal-footer {
        border-top: none;
    }

    .modal-custom .modal-footer .col-xs-6.left {
        padding-right: 6px;
    }

    .modal-custom .modal-footer .col-xs-6.right {
        padding-left: 6px;
    }
</style>
